import { Component } from "react";

// Keeps one broken component from blanking the whole funnel.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink-950 px-6 text-center">
          <div>
            <p className="font-display text-2xl text-fg">Something went wrong.</p>
            <p className="mt-3 text-sm text-fg-muted">Please refresh the page.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
